import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MOBILE_NAV_ITEMS = [
  { path: '/dashboard', icon: '🏠', label: 'Home' },
  { path: '/dashboard/location', icon: '📍', label: 'Location' },
  { path: '/dashboard/chat', icon: '💬', label: 'Chat' },
  { path: '/dashboard/analytics', icon: '📊', label: 'Analytics' },
  { path: '/dashboard/sos', icon: '🆘', label: 'SOS' },
];

export default function InstagramBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="instagram-bottom-nav">
      {MOBILE_NAV_ITEMS.map(item => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            className={`instagram-nav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
            title={item.label}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        );
      })}

      <style>{`
        .instagram-bottom-nav {
          display: none;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(180deg, rgba(13,21,40,0.95), rgba(13,21,40,0.98));
          backdrop-filter: blur(10px);
          border-top: 1px solid var(--border);
          z-index: 99;
          padding: 8px 0 16px 0;
          gap: 0;
          justify-content: space-around;
          align-items: flex-start;
        }

        @media (max-width: 768px) {
          .instagram-bottom-nav {
            display: flex;
          }
        }

        .instagram-nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          background: none;
          border: none;
          color: var(--text-secondary);
          cursor: pointer;
          padding: 8px 12px;
          transition: all 0.2s ease;
          font-size: 12px;
          font-weight: 500;
          flex: 1;
          max-width: 70px;
        }

        .instagram-nav-item:hover {
          color: var(--text-primary);
        }

        .instagram-nav-item.active {
          color: var(--blue);
          transform: scale(1.05);
        }

        .instagram-nav-item.active::after {
          content: '';
          position: absolute;
          bottom: -8px;
          width: 3px;
          height: 3px;
          background: var(--blue);
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        .nav-icon {
          font-size: 20px;
          display: inline-block;
          transition: transform 0.2s ease;
        }

        .instagram-nav-item:active .nav-icon {
          transform: scale(0.9);
        }

        .nav-label {
          font-size: 11px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.5); }
        }
      `}</style>
    </nav>
  );
}
